import {
  dbui_v1_CreateNotebookRequest,
  dbuiV1CreateNotebookMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useCreateNotebook = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    mutationFn: (data: dbui_v1_CreateNotebookRequest) =>
      dbuiV1CreateNotebookMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
